import { render, staticRenderFns } from "./addedit-role.vue?vue&type=template&id=273cfbb1&scoped=true"
import script from "./addedit-role.vue?vue&type=script&lang=js"
export * from "./addedit-role.vue?vue&type=script&lang=js"
import style0 from "./addedit-role.vue?vue&type=style&index=0&id=273cfbb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273cfbb1",
  null
  
)

export default component.exports